import { sheetsApi } from "../data/urls";

export const getIsSheetsApiUrl = (url: string) => {
  if (!url || typeof url !== "string") return false;
  return url.startsWith(sheetsApi);
};
